export default __webpack_public_path__ + "static/media/me-new-3.5a37fa71.jpg";